import { render, staticRenderFns } from "./literatureItem.vue?vue&type=template&id=c1b950d6&scoped=true&"
import script from "./literatureItem.vue?vue&type=script&lang=js&"
export * from "./literatureItem.vue?vue&type=script&lang=js&"
import style0 from "./literatureItem.vue?vue&type=style&index=0&id=c1b950d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b950d6",
  null
  
)

export default component.exports